// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "flight-2Nfr2";
var _3 = "routes-FLvNt";
var _4 = "segments-2Cm-C";
var _5 = "duration-hiQ6E";
var _6 = "slider__wrapper-2Mk_9";
var _7 = "modal__button_right-3BGNa";
export { _1 as "__esModule", _2 as "flight", _3 as "routes", _4 as "segments", _5 as "duration", _6 as "slider__wrapper", _7 as "modal__button_right" }
export default { "__esModule": _1, "flight": _2, "routes": _3, "segments": _4, "duration": _5, "slider__wrapper": _6, "modal__button_right": _7 }
